<template>
  <div class="chart-container">
    <v-chart
      ref="vchart"
      :options="options"
      theme="light"
      autoresize
      @legendselectchanged="handleLegendSelectChange"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseEChart',

  props: ['options'],

  computed: {
    filterOptions () {
      return {
        ...this.options,
        animation: true,
        parallel: {
          width: '100%',
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
      }
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('legendselectchanged', params)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseEChart.vue